document.addEventListener('DOMContentLoaded', function(evt) {
  const body = document.querySelector('body');

  // =====================================================
  // Login & Registration forms are now pre-rendered in include-login.liquid
  // with proper {% form %} tags. Shopify's CAPTCHA system handles them.
  // The flyout open/close/tab logic is also in include-login.liquid.
  // No additional handling needed here.
  // =====================================================

  // Trigger variant selection on product pages (only if swatch exists)
  // Wait for jQuery and product JS to be ready before triggering click
  if (window.location.href.includes("/products")) {
    var waitForJQuery = setInterval(function() {
      if (typeof $ !== 'undefined' && $.fn && $.fn.jquery) {
        clearInterval(waitForJQuery);
        $(document).ready(function() {
          setTimeout(function() {
            var widthButton = document.querySelector('.size-swatch');
            if (widthButton) {
              widthButton.click();
            }
          }, 100);

          // Show notification when user clicks add-to-cart without selecting a Talla (size)
          $('body').on('click', '.prices-add-to-cart-actions button.add-to-cart', function(e) {
            var $msg = $('.size-not-selected-msg');
            // .size-not-selected-msg is only rendered by Liquid for products with 3 options (Color+Width+Size)
            if ($msg.length === 0) {
              return; // no size validation needed for this product
            }
            // Size is always the last attribute container with size-swatch elements
            var $sizeContainer = $('.attribute').has('.size-swatch').last();
            var sizeSelected = $sizeContainer.find('.size-swatch.selected').length > 0;
            if (!sizeSelected) {
              e.stopImmediatePropagation();
              e.preventDefault();
              $msg.fadeIn(300);
              // Auto-hide after 5 seconds
              clearTimeout(window._sizeNotifTimeout);
              window._sizeNotifTimeout = setTimeout(function() {
                $msg.fadeOut(300);
              }, 5000);
              return false;
            } else {
              $msg.hide();
            }
          });

          // Hide notification when a size swatch is clicked
          $('body').on('click', '.size-swatch', function() {
            $('.size-not-selected-msg').hide();
          });

          // Hide out-of-stock variants after each attribute selection update
          $('body').on('product:afterAttributeSelect', function(e, response) {
            if (response.data && response.data.product && response.data.product.variationAttributes) {
              response.data.product.variationAttributes.forEach(function(attr) {
                attr.values.forEach(function(val) {
                  var swatch = response.container.find('[data-attr="' + attr.id + '"] [data-attr-value="' + val.value + '"]');
                  if (!val.selectable) {
                    swatch.hide();
                  } else {
                    swatch.show();
                  }
                });
              });
            }
          });
        });
      }
    }, 50);
  }

  // Activate Slick slideshow
  if (body.classList.contains('template-index')) {
    var waitForSlick = setInterval(function() {
      if (typeof $ !== 'undefined' && $.fn && $.fn.slick) {
        clearInterval(waitForSlick);
        var $slideshow = $('.slideshow__list');
        var slideCount = $slideshow.children().length;

        if (slideCount > 0) {
          $slideshow.slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: true,
            arrows: slideCount > 1,
            dots: slideCount > 1,
            autoplay: slideCount > 1,
            autoplaySpeed: 5000
          });
        }
      }
    }, 50);
  }
});